module.exports = __webpack_public_path__ + "817ea04ee45e21401a54a680b7f07971.MP3";